import React from 'react';
import { motion } from 'framer-motion';
import { useTexts } from '../../../hooks/useTexts';
import './Services.css';

export default function Services() {
  const t = useTexts();

  return (
    <section className="services-section" id="services">
      <div className="services-header">
        <p className="section-num">{t.services.sectionNum}</p>
        <h2 className="section-title">
          {t.services.title1}<br />
          <span className="outline">{t.services.title2}</span>
        </h2>
      </div>

      <div className="services-grid">
        {t.services.items.map((item, i) => (
          <motion.div
            key={i}
            className="service-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
          >
            <div className="service-num">{item.num}</div>
            <h3 className="service-title">{item.title}</h3>
            <p className="service-desc">{item.desc}</p>
            <div className="service-tags">
              {item.tags.map(tag => (
                <span key={tag} className="service-tag">{tag}</span>
              ))}
            </div>
            <div className="service-line" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
